import { StagedFieldsGroupPresenter } from '@/forms/components/presenters/StagedFieldsGroupPresenter';
import {
  FormFieldType,
  type StagedFieldsGroupFormField,
} from '@/forms/typings';

import type { FormFieldModule } from '../registry/field-module.types';

import { buildStagedFieldsGroupInitialState } from './initialState';

export const stagedFieldsGroupFieldModule: FormFieldModule = {
  type: FormFieldType.StagedFieldsGroup,
  Presenter: ({ field, disabled }) => (
    <StagedFieldsGroupPresenter
      field={field as StagedFieldsGroupFormField}
      disabled={disabled}
    />
  ),
  flattenLeaves: (field, ctx) => {
    const f = field as StagedFieldsGroupFormField;
    return ctx.recurse([...f.firstStageFields, ...f.otherFields]);
  },
  buildInitialState: buildStagedFieldsGroupInitialState,
};
